import React, { Component, PureComponent } from "react";
import PhoneInput from "../phone-input";
import { Phone } from "../../core/api/models";
import { DropdownList } from "react-widgets";

interface Props {
  placeholder?: string;
  onChange: (val: Phone[], dialCode?: string) => void;
  value?: Phone[];
  className?: string;
  isEdit?: boolean;
  onUpdate?: (val: Phone[]) => void; 
}

interface SingleProps {
  onChange: (val: Phone, dialCode?: string) => void;
  onRemove: () => void; 
  value: Phone;
  isEdit?: boolean;
  index: number;
  totalItems: number;
}

interface State {
  phones: Phone[];
}

const PhoneType = [
  { name: "Mobile", value: "Mobile" },
  { name: "Home", value: "Home" },
  { name: "Office", value: "Office" },
];

class SinglePhoneInput extends PureComponent<SingleProps> {
  setAsPrimary = () => {
    const { value, totalItems } = this.props;
    if (totalItems > 1 && !value.isPrimary) {
      value.isPrimary = !value.isPrimary;
      this.props.onChange(value);
    }
  };

  setType = (type: { name: string; value: string }) => {
    const { value } = this.props;
    value.phoneType = type.value;
    this.props.onChange(value);
  };

  setPhone = (event: { phone: string, country: any  }) => {       
    const { value } = this.props;
    value.phone = event.phone;
    this.props.onChange(value, event.country.dialCode);  
  };

  render() {
    return (
      <div className="row gutter-5 mb-2 w-100">
        <div className="col input-group phone-group">
          <div className="col-8 p-0">
            <PhoneInput
              value={`${this.props.value.phone}`}
              onChange={(phone, country) => this.setPhone({ phone, country })}
            />
          </div>
          <div className="col-4 p-0">
            <DropdownList
              value={this.props.value.phoneType}
              defaultValue={this.props.value.phoneType}
              data={PhoneType}
              textField={"name"}
              valueField={"value"}
              placeholder={"Select Address Type"}
              onChange={this.setType}
            />
          </div>
        </div>

        <div className="col-auto">
          <div
            onClick={this.setAsPrimary}
            className={`set-primary form-control font-sm h-100 px-2 d-flex align-items-center justify-content-center cursor-pointer ${
              this.props.value.isPrimary ? "text-shamrock" : "text-gray-400"
            }`}
          >
            <i className="icon-tick"></i>
          </div>
        </div>
        {this.props.index > 1 && (
          <div className="col-auto d-flex">
            <i
              onClick={this.props.onRemove}
              className="icon-bin-fill cursor-pointer align-self-center font-lg text-gray-700"
            ></i>
          </div>
        )}
      </div>
    );
  }
}

// tslint:disable-next-line: max-classes-per-file
class OtpInput extends Component<Props, State> {
  static defaultProps = {
    value: "",
  };

  state = {
    phones:
      this.props.value && this.props.value.length > 0
        ? this.props.value
        : [
            {
              phone: "+91",
              phoneType: "Mobile",
              isPrimary: true,
              dialCode: "91"
            },
          ],
  };

  addMorePhone = () => {
    const { phones } = this.state;
    phones.push({
      phone: "+91",
      phoneType: "Mobile",
      isPrimary: false,
      dialCode: "91"
    });
    this.setState({ phones });
  };

  handleOnChange = (phone: Phone, index: number) => {     
    const { onChange } = this.props;
    let { phones } = this.state;

    if (phone.isPrimary) {
      phones = phones.length
        ? phones.map((d: Phone) => {
            return {
              ...d,
              isPrimary: false              
            };
          })
        : [];
    }

    phones[index] = phone;
    if (!phones.find((x) => x.isPrimary)) {
      phones[0].isPrimary = true;
    }
    this.setState({ phones });
    onChange(phones);
  };

  handleOnRemove = (index: number) => {
    const { onChange } = this.props;
    const { phones } = this.state;
    phones.splice(index, 1);
    if (!phones.find((x) => x.isPrimary)) {
      phones[phones.length - 1].isPrimary = true;
    }
    this.setState({ phones });
    onChange(phones);
    if (this.props.isEdit && this.props.onUpdate) {
      this.props.onUpdate(phones);
    }
  };

  renderInputs = () => {
    const { phones } = this.state;

    const inputs = [];

    for (let i = 0; i < phones.length; i++) {
      inputs.push(
        <SinglePhoneInput
          onChange={(value: Phone, dialCode?: string) => this.handleOnChange( {...value, dialCode }, i)}
          value={phones[i]}
          isEdit={this.props.isEdit}
          onRemove={() => this.handleOnRemove(i)}
          index={phones.length}
          totalItems={phones.length}          
        />
      );
    }

    return inputs;
  };

  render() {
    return (
      <>
        {this.renderInputs()}
        <div className="w-100"></div>
        <button
          type="button"
          className="btn btn-link font-sm p-0 font-weight-semibold"
          onClick={this.addMorePhone}
        >
          + add one more
        </button>
      </>
    );
  }
}

export default OtpInput;
